import { Component, OnDestroy } from '@angular/core';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

//COMPONENTS
import { PurchaseOrderInlineFormComponent } from '@app/modules/purchase-orders/purchase-order-inline-form/purchase-order-inline-form.component';

import { OrderTransferFormComponent } from '../../../order/components/order-transfer-form/order-transfer-form.component';

//INTERFACE

//CONFIG
import { DialogConfig } from '../../../shared/configs/';

// UTILS
import { trackById } from '../../../shared/util/track-by.util';
import { IStock } from '../../interfaces/stock.interface';

// SERVICES
import { StockFacadeService } from './../../../shared/services/facades/stock/stock.facade.service';

@Component({
  selector: 'lum-stock-sidebar',
  templateUrl: './stock-sidebar.component.html',
  styleUrls: ['./stock-sidebar.component.scss'],
})
export class StockSidebarComponent implements OnDestroy {
  trackById = trackById;

  private onDestroy$ = new Subject();

  constructor(
    private stockFacadeService :StockFacadeService,
    private dialog :MatDialog,
  ) {}

  ngOnDestroy() :void {
    this.onDestroy$.next(null);
    this.onDestroy$.complete();
  }

  createTransferOrder() :void {
    const uniqueRfqIds = [...new Set(this.selectedRows.map((item) => item.rfqId))];

    const stockGridItemIds = uniqueRfqIds.join(',');

    this.dialog
      .open(OrderTransferFormComponent, {
        width: DialogConfig.sizes['xxx-large'],
        height: 'auto',
        maxHeight: '90vh',
        data: {
          isModal: true,
          stockGridItemIds: stockGridItemIds,
        },
      })
      .afterClosed()
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((result) => {
        if (result) {
          this.stockFacadeService.resetSelectedRows();
        }
      });
  }

  createPurchaseOrder() :void {
    const uniqueRfqIds = [...new Set(this.selectedRows.map((item) => item.rfqId))];

    const stockGridItemIds = uniqueRfqIds.join(',');

    this.dialog
      .open(PurchaseOrderInlineFormComponent, {
        width: DialogConfig.sizes['xxx-large'],
        height: 'auto',
        maxHeight: '90vh',
        data: {
          isModal: true,
          stockGridItemIds: stockGridItemIds,
        },
      })
      .afterClosed()
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((result) => {
        if (result) {
          this.stockFacadeService.resetSelectedRows();
        }
      });
  }

  get selectedRows() :IStock[] {
    return this.stockFacadeService.selectedRows;
  }
}
